import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box, Fab, useMediaQuery } from '@mui/material';
import { AnimatePresence, motion } from 'framer-motion';
import ScrollToTop from './components/ScrollToTop';
import theme from './theme';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LandingPage from './Pages/LandingPage';
import ServicesPage from './Pages/ServicesPage';
import ContactUsPage from './Pages/ContactUsPage';
import AboutUsPage from './Pages/AboutUsPage';
import NotFound from './Pages/NotFound';
import ProductDetailsPage from './Pages/ProductDetailsPage';
import ChatBox from './components/Chat/ChatBox';
import { useCookieConsent } from './components/CookiePermission';
import FusionAIIcon from './Media/FusionAI.png';

function App() {
  const [showChat, setShowChat] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const { cookiesAllowed, CookieBanner } = useCookieConsent();

  const isMobile = useMediaQuery('(max-width:600px)');

  // Trigger the animation after component mount
  useEffect(() => {
    // ( Small delay to ensure the page is loaded before animation starts )
    const timer = setTimeout(() => {
      setShowButton(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const toggleChat = () => {
    setShowChat(!showChat);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <ScrollToTop />
        <Box sx={{ overflow: 'hidden' }}>
          <Navbar />
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                >
                  <LandingPage />
                </motion.div>
              } />
              <Route path="/Services" element={
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                >
                  <ServicesPage />
                </motion.div>
              } />
              <Route path="/Contact" element={
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                >
                  <ContactUsPage />
                </motion.div>
              } />
              <Route path="/About" element={
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                >
                  <AboutUsPage />
                </motion.div>
              } />
              <Route path="/product-details" element={
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                >
                  <ProductDetailsPage />
                </motion.div>
              } />
              <Route path="*" element={
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                >
                  <NotFound />
                </motion.div>
              } />
            </Routes>
          </AnimatePresence>
          <Footer />
          {/* Cookie consent banner will show automatically if needed */}
          <CookieBanner />
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
